module.exports = __webpack_public_path__ + "22-o2.jpg?73eed7748edaa058c2f5a347399d038c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/22-o2.jpg
// module id = 645
// module chunks = 0